import type {
  AnyVariableType,
  VariableID,
} from '@packages/systems/core/utils/StyleVariables';
import {Plugins} from '@packages/systems/wfdl';
import {Qualified, qualify} from '@packages/systems/wfdl-Qualified';

export const getAllStyleVariablesToInclude = (
  variablesIds: Set<string>,
  variableMap: Map<string, AnyVariableType>
) => {
  const variables: Record<string, AnyVariableType> = {};
  for (const id of variablesIds) {
    const variable = variableMap.get(id);
    if (variable) {
      variables[id] = variable;

      // check is variable is a reference to another variable and if it is we need to include that one too
      const val = variable.value;
      if (val != null && val.type === 'ref') {
        // this variable id will be iterated over at the end of the collection, ensuring that
        // we capture references to other references
        variablesIds.add(val.value.variableId);
      }
    }
  }

  return variables;
};

export const getAllStyleVariablesAsPluginReferences = (
  variablesIds: Set<VariableID>,
  pluginId: string = ''
): Array<Qualified<VariableID>> => {
  const variables: Array<Qualified<VariableID>> = [];
  for (const id of variablesIds) {
    variables.push(qualify(Plugins.name(pluginId), id));
  }
  return variables;
};
